import dataRoamingApi from '@/api/dataRoaming/dataRoamingApi';
import event from '@/event-bus/event';

export default {
	name: 'country-roam-confirm-alert',
	mixins: [],
	extends: {},
	components: {},
	props: ['countryRoamItem','roamItem','dataRoamFlagSwitch','width','isShow', 'cbFun'],
	data() {
		return {
			countryRoamList: [],
			countryList:[],
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			this.getContryRoam();
		},
		async getContryRoam() {
			// 取得Single卡可啟用漫遊國家清單
			this.countryRoamList = await dataRoamingApi.getCountryRoamingItem();
			this.countryList = Array.from(new Set(this.countryRoamList.map(e => e.countryName)));
		},
		async addRoamItem() {
			this.$emit('close');
			this.$bus.$emit(event.addRoamItemAlert, this.roamItem);
		},
		async switchDataRoaming() {
			this.$emit('close');
			const dataRoamFlagSwitch = {
				isShow: this.isShow,
				showReservationWarn: this.dataRoamFlagSwitch.showReservationWarn,
				dataRoamFlag: this.dataRoamFlagSwitch.dataRoamFlag
			}
			this.$bus.$emit(event.switchDataRoamingAlert , dataRoamFlagSwitch );
		},
		async changeVoiceBasicStatus4Roaming() {
			let resp = await dataRoamingApi.changeVoiceBasicStatus4Roaming(this.countryRoamItem.serviceID, this.countryRoamItem.applyStatusARW,this.countryRoamItem.applyStatusCDW);
			if (resp) {
				this.$emit('close');
				this.$router.push({ name: 'gt-success', params: { title: '國際語音漫遊服務', msg: '國際語音漫遊服務已設定成功', returnName: 'voice-roaming' } });
			}
		},
		close() {
			this.$emit('close');
			this.$bus.$emit(event.validateAlert, '請洽客服或直營門市進行換卡');
		},
		getCountryMaxLine(){
			return Math.ceil((this.countryList.length-1)/10);
		},
		callBack() {
			this.cbFun();
			this.$emit('close');
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/service/alert/countryRoamConfirm-alert.js